export default {
  BEFORE: Symbol('BEFORE'),
  AFTER: Symbol('AFTER'),
};
